module.exports = __webpack_public_path__ + "static/media/sign-up-img-4_mobile.60aaaf44.png";